import React, { useEffect, useState } from "react";
import AddOpportunityTab from "./components/Modals/AddOpportunityTab";
import { useAppServices } from "../../../../hook/services";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";

const OpportunityTabs = () => {
  const AppService = useAppServices();
  const { companyId, type, customizationId } = useParams();
  const [opportunityTabs, setOpportunityTabs] = useState([]);
  const [data, setData] = useState({});
  const [loader, setLoader] = useState(true);
  const [deletingIndex, setDeletingIndex] = useState(null);

  const handler =
    type === "agency" || type === "location"
      ? AppService.sidenav_customizer_main_level
      : type === "group"
      ? AppService.sidenav_customizer_custom_level
      : AppService.sidenav_customizer_saas_level;

  const query =
    type === "location" || type === "agency"
      ? `companyId=${companyId}&type=${type}`
      : `_id=${customizationId}`;

  const getData = async () => {
    setLoader(true);
    try {
      const { response } = await handler.filter({ query });
      if (response?.data) {
        setOpportunityTabs(response.data.opportunity_tabs || []);
        setData(response.data);
      } else {
        setOpportunityTabs([]);
        setData({});
      }
    } catch (error) {
      console.error("Failed to fetch opportunity tabs:", error);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const handleDelete = async (editIndex) => {
    if (editIndex === null || editIndex < 0 || !data?._id) {
      toast.error("Invalid delete request.");
      return;
    }

    const opportunity_tabs = data?.opportunity_tabs
      ? [...data.opportunity_tabs]
      : [];
    opportunity_tabs.splice(editIndex, 1);

    const payload = {
      opportunity_tabs,
      companyId,
      _id: data._id,
    };

    try {
      setDeletingIndex(editIndex);
      const { response } = await handler.update({ payload });
      if (response) {
        toast.success("Tab deleted.");
        getData();
      } else {
        toast.error("Failed to delete the tab.");
      }
    } catch (error) {
      console.error("Delete error:", error);
      toast.error("An error occurred while deleting.");
    } finally {
      setDeletingIndex(null);
    }
  };

  return (
    <div className="ot-list-wrapper">
      <style>{`
        .ot-list-wrapper {
          background: #ffffff;
          border-radius: 16px;
          padding: 22px 24px;
          border: 1px solid #e2e8f0;
        }
        .ot-list-header {
          display: flex;
          align-items: flex-start;
          justify-content: space-between;
          gap: 16px;
          flex-wrap: wrap;
          margin-bottom: 20px;
        }
        .ot-list-title {
          margin: 0;
          font-size: 18px;
          font-weight: 600;
          color: #0f172a;
          display: flex;
          align-items: center;
          gap: 10px;
        }
        .ot-list-title .ot-badge {
          background: #eef2ff;
          color: #4338ca;
          font-size: 12px;
          font-weight: 600;
          border-radius: 999px;
          padding: 2px 10px;
        }
        .ot-list-subtitle {
          color: #64748b;
          font-size: 13px;
          margin: 4px 0 0;
        }
        .ot-empty {
          border: 1px dashed #cbd5e1;
          border-radius: 14px;
          padding: 48px 20px;
          text-align: center;
          background: linear-gradient(180deg, #f8fafc 0%, #eef2ff 100%);
        }
        .ot-empty .ot-empty-icon {
          width: 56px;
          height: 56px;
          border-radius: 16px;
          background: #fff;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          color: #4f46e5;
          font-size: 26px;
          box-shadow: 0 8px 24px rgba(79, 70, 229, 0.18);
          margin-bottom: 14px;
        }
        .ot-empty h6 {
          font-size: 15px;
          color: #0f172a;
          font-weight: 600;
          margin: 0 0 4px;
        }
        .ot-empty p {
          color: #64748b;
          font-size: 13px;
          margin: 0 0 14px;
        }
        .ot-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
          gap: 14px;
        }
        .ot-card {
          background: #ffffff;
          border: 1px solid #e2e8f0;
          border-radius: 14px;
          padding: 16px;
          display: flex;
          flex-direction: column;
          gap: 12px;
          transition: border-color 0.15s, box-shadow 0.15s;
        }
        .ot-card:hover {
          border-color: #c7d2fe;
          box-shadow: 0 8px 24px rgba(15, 23, 42, 0.06);
        }
        .ot-card-preview {
          background: linear-gradient(180deg, #f8fafc 0%, #eef2ff 100%);
          border-radius: 10px;
          padding: 18px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .ot-card-tab {
          background: #eef2ff;
          border: 1px solid #c7d2fe;
          color: #1e3a8a;
          font-weight: 600;
          font-size: 12px;
          padding: 8px 14px;
          border-radius: 6px;
          display: inline-flex;
          align-items: center;
          gap: 8px;
          min-width: 180px;
          max-width: 100%;
          box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);
        }
        .ot-card-meta {
          display: flex;
          flex-direction: column;
          gap: 6px;
        }
        .ot-card-meta .ot-card-name {
          font-size: 14px;
          font-weight: 600;
          color: #0f172a;
          margin: 0;
          word-break: break-word;
        }
        .ot-card-meta .ot-card-row {
          font-size: 12px;
          color: #64748b;
          display: flex;
          align-items: center;
          gap: 6px;
          word-break: break-all;
        }
        .ot-card-meta .ot-card-row > span.text-truncate {
          min-width: 0;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .ot-pill {
          display: inline-flex;
          align-items: center;
          gap: 4px;
          font-size: 11px;
          padding: 2px 8px;
          border-radius: 999px;
          font-weight: 500;
          flex-shrink: 0;
        }
        .ot-pill.url { background: #ecfeff; color: #0e7490; }
        .ot-pill.contact { background: #f0fdf4; color: #15803d; }
        .ot-pill.fields { background: #fef3c7; color: #92400e; }
        .ot-card-flags {
          display: flex;
          flex-wrap: wrap;
          gap: 6px;
        }
        .ot-card-actions {
          display: flex;
          align-items: center;
          gap: 8px;
          margin-top: 4px;
          padding-top: 12px;
          border-top: 1px solid #f1f5f9;
        }
        .ot-card-actions .ot-action-btn {
          flex: 1;
          border: 1px solid #e2e8f0;
          background: #fff;
          color: #475569;
          border-radius: 8px;
          padding: 6px 10px;
          font-size: 12px;
          font-weight: 500;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 6px;
          transition: all 0.15s;
        }
        .ot-card-actions .ot-action-btn:hover {
          background: #f8fafc;
          color: #0f172a;
        }
        .ot-card-actions .ot-action-btn.delete {
          color: #b91c1c;
          border-color: #fecaca;
          background: #fef2f2;
        }
        .ot-card-actions .ot-action-btn.delete:hover {
          background: #fee2e2;
          color: #991b1b;
        }
        .ot-card-actions .ot-edit-slot { flex: 1; display: flex; }
        .ot-card-actions .ot-edit-slot > * { width: 100%; }
        .ot-card-actions .ot-edit-slot .btn {
          width: 100%;
          padding: 6px 10px;
          font-size: 12px;
          font-weight: 500;
          gap: 6px;
        }
        .ot-skeleton {
          height: 200px;
          border-radius: 14px;
          background: linear-gradient(90deg, #f1f5f9 0%, #e2e8f0 50%, #f1f5f9 100%);
          background-size: 200% 100%;
          animation: otSkeleton 1.5s ease-in-out infinite;
        }
        @keyframes otSkeleton {
          0% { background-position: 200% 0; }
          100% { background-position: -200% 0; }
        }
      `}</style>

      <div className="ot-list-header">
        <div>
          <h3 className="ot-list-title">
            <i className="bi bi-collection text-primary" />
            Opportunity Tabs
            {!loader && (
              <span className="ot-badge">{opportunityTabs.length}</span>
            )}
          </h3>
          <p className="ot-list-subtitle">
            Custom tabs that appear inside the GHL opportunity detail modal.
          </p>
        </div>
        {!loader && <AddOpportunityTab data={data} handleRefresh={getData} />}
      </div>

      {loader ? (
        <div className="ot-grid">
          <div className="ot-skeleton" />
          <div className="ot-skeleton" />
          <div className="ot-skeleton" />
        </div>
      ) : opportunityTabs.length === 0 ? (
        <div className="ot-empty">
          <div className="ot-empty-icon">
            <i className="bi bi-collection" />
          </div>
          <h6>No opportunity tabs yet</h6>
          <p>
            Add a tab to embed your own pages inside the opportunity detail
            modal.
          </p>
          <AddOpportunityTab data={data} handleRefresh={getData} />
        </div>
      ) : (
        <div className="ot-grid">
          {opportunityTabs.map((item, index) => (
            <div className="ot-card" key={index}>
              <div className="ot-card-preview">
                <span className="ot-card-tab" title={item.name}>
                  {item.icon && (
                    <i
                      className={`${item.iconFamily || "fas"} fa-${item.icon}`}
                      style={{ fontSize: 12 }}
                    />
                  )}
                  <span className="text-truncate">{item.name}</span>
                </span>
              </div>

              <div className="ot-card-meta">
                <p className="ot-card-name" title={item.name}>
                  {item.name}
                </p>
                {item.link && (
                  <div className="ot-card-row">
                    <span className="ot-pill url">
                      <i className="bi bi-globe" />
                      URL
                    </span>
                    <span className="text-truncate" title={item.link}>
                      {item.link}
                    </span>
                  </div>
                )}
                <div className="ot-card-flags">
                  {item.sendContact && (
                    <span className="ot-pill contact">
                      <i className="bi bi-person-check" />
                      Contact + opportunity
                    </span>
                  )}
                  {item.customFields && (
                    <span className="ot-pill fields">
                      <i className="bi bi-list-task" />
                      Custom fields
                    </span>
                  )}
                </div>
              </div>

              <div className="ot-card-actions">
                <div className="ot-edit-slot">
                  <AddOpportunityTab
                    data={data}
                    handleRefresh={getData}
                    selectedTab={item}
                    editIndex={index}
                  />
                </div>
                <button
                  className="ot-action-btn delete"
                  title="Delete"
                  onClick={() => handleDelete(index)}
                  disabled={deletingIndex === index}
                >
                  {deletingIndex === index ? (
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    />
                  ) : (
                    <>
                      <i className="bi bi-trash" />
                      Delete
                    </>
                  )}
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default OpportunityTabs;
